import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useTranslation } from 'react-i18next';

export const Navbar = () => {
   const [menuOpen, setMenuOpen] = useState(false);
   const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
   const isMobile = useIsMobile();
   const { t } = useTranslation();

   const navSections = [
      { key: 'mariage', label: t('navbar.wedding') },
      { key: 'pratique', label: t('navbar.useful') },
      { key: 'tourisme', label: t('navbar.tourism') },
   ];

   useEffect(() => {
      document.body.style.overflow = menuOpen ? 'hidden' : '';
      return () => {
         document.body.style.overflow = '';
      };
   }, [menuOpen]);

   const toggleDropdown = (key: string) => {
      setActiveDropdown(activeDropdown === key ? null : key);
   };

   const handleLinkClick = () => {
      setMenuOpen(false);
      setActiveDropdown(null);
   };

   return (
      <nav className="navbar">
         <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
         </button>

         <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <div className="nav-item">
               <Link to="/" onClick={handleLinkClick}>
                  {t('navbar.home')}
               </Link>
            </div>

            {navSections.map(({ key, label }) => (
               <div className="nav-item dropdown" key={key}>
                  {isMobile ? (
                     <span
                        onClick={() => toggleDropdown(key)}
                        className={`nav-toggle ${activeDropdown === key ? 'open' : ''}`}
                     >
                        <span className="nav-toggle-inner">
                           <span className="arrow" />
                           <span className="label">{label}</span>
                        </span>
                     </span>
                  ) : (
                     <Link to={`/${key}`}>{label}</Link>
                  )}

                  <div className={`dropdown-content ${activeDropdown === key ? 'open' : ''}`}>
                     {key === 'mariage' && (
                        <>
                           <Link to="/mariage#ceremonie" onClick={handleLinkClick}>
                              {t('navbar.weddingSections.ceremony')}
                           </Link>
                           <Link to="/mariage#reception" onClick={handleLinkClick}>
                              {t('navbar.weddingSections.reception')}
                           </Link>
                        </>
                     )}
                     {key === 'pratique' && (
                        <>
                           <Link to="/pratique#deplacement" onClick={handleLinkClick}>
                              {t('navbar.usefulSections.transport')}
                           </Link>
                           <Link to="/pratique#logement" onClick={handleLinkClick}>
                              {t('navbar.usefulSections.accommodation')}
                           </Link>
                           <Link to="/pratique#venir" onClick={handleLinkClick}>
                              {t('navbar.usefulSections.coming')}
                           </Link>
                           <Link to="/pratique#contact" onClick={handleLinkClick}>
                              {t('navbar.usefulSections.contact')}
                           </Link>
                        </>
                     )}
                     {key === 'tourisme' && (
                        <>
                           <Link to="/tourisme#nature" onClick={handleLinkClick}>
                              {t('navbar.tourismSections.nature')}
                           </Link>
                           <Link to="/tourisme#enfant" onClick={handleLinkClick}>
                              {t('navbar.tourismSections.child')}
                           </Link>
                           <Link to="/tourisme#gratuit" onClick={handleLinkClick}>
                              {t('navbar.tourismSections.free')}
                           </Link>
                           <Link to="/tourisme#insolite" onClick={handleLinkClick}>
                              {t('navbar.tourismSections.unusual')}
                           </Link>
                           <Link to="/tourisme#touristique" onClick={handleLinkClick}>
                              {t('navbar.tourismSections.touristic')}
                           </Link>
                           <Link to="/tourisme#festif" onClick={handleLinkClick}>
                              {t('navbar.tourismSections.festive')}
                           </Link>
                           <Link to="/tourisme#favoris" onClick={handleLinkClick}>
                              {t('navbar.tourismSections.favorites')}
                           </Link>
                        </>
                     )}
                  </div>
               </div>
            ))}

            <div className="nav-item">
               <Link to="/faq" onClick={handleLinkClick}>
                  {t('navbar.faq')}
               </Link>
            </div>
         </div>
      </nav>
   );
};
